import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import InputMask from "react-input-mask";
import styles from "../../../../../styles/global-styles";
import ChipCategorySelect from "../../../../shared/selects/ChipCategorySelect";
import { ProductService } from "../../../../../services/product.service";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
}));

const ChipHeader = ({
  chipArray,
  chipsInSite,
  chipsFiltered,
  searchByIccid,
  chipByIccid,
}) => {
  const classes = useStyles();

  const [queryParams, setqueryParams] = useState({});
  const [iccid, setIccid] = useState("");

  useEffect(() => {
    if (!Object.keys(chipByIccid).length) {
      setIccid("");
    }
  }, [chipByIccid]);

  const handleQuerySelected = (key, value) =>
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });

  const searchChipByFilters = async () => {
    try {
      const { data } = await ProductService.getProductByChipsWithParams(
        queryParams
      );
      if (data.length) {
        const chipObject = {
          chips: [data[0].chip],
          count: 1,
          params: queryParams,
        };
        chipsFiltered(chipObject, true);
      } else {
        const errorChipsFiltered = {
          mssgError: "No se encontraron chips de la categoría seleccionada",
        };
        throw errorChipsFiltered;
      }
    } catch (error) {
      chipsFiltered(error, false);
    }
  };

  const searchChipByIccid = async () => {
    const body = {
      iccid,
      productSold: false,
    };
    console.log("body to search ", body);

    try {
      const { data } = await ProductService.getProductByChipsWithParams(body);
      if (data.length) {
        searchByIccid(chipsInSite ? data[0] : data[0].chip, true);
      } else {
        const errorChipByIccid = {
          mssgError: `No se encontró en sucursal el ICCID  ${iccid}`,
        };
        throw errorChipByIccid;
      }
    } catch (error) {
      searchByIccid(error, false);
    }
  };

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h4" component="h4" className={classes.title}>
          Inventario chips
        </Typography>
      </Grid>

      {chipArray?.length > 0 && (
        <>
          {!chipsInSite && (
            <>
              <Grid item>
                <ChipCategorySelect category={handleQuerySelected} />
              </Grid>
              <Grid item>
                <Button
                  className={classes.rightButton}
                  variant="contained"
                  onClick={searchChipByFilters}
                  color="primary"
                  endIcon={<SearchIcon color="secondary" />}
                >
                  Filtrar
                </Button>
              </Grid>
            </>
          )}
        </>
      )}

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ marginTop: 10 }}
      >
        {chipArray?.length > 0 && (
          <>
            <Grid item>
              <Typography className={classes.header}>
                Búsqueda por ICCID
              </Typography>
            </Grid>
            <Grid item>
              <InputMask
                mask="9999999999999999999"
                maskChar=""
                value={iccid || ""}
                onChange={(e) => setIccid(e.target.value)}
              >
                {() => (
                  <TextField
                    className={classes.inputField}
                    name="imeiCode"
                    placeholder="ICCID"
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item>
              <Button
                className={classes.rightButton}
                variant="contained"
                onClick={searchChipByIccid}
                color="primary"
                endIcon={<SearchIcon color="secondary"></SearchIcon>}
              >
                Buscar
              </Button>
            </Grid>
            <Grid item xs={3}></Grid>
          </>
        )}
        {!chipsInSite && (
          <Grid item>
            <Link
              to={{
                pathname: `../inventario/captura`,
                state: { tabOption: 3 },
              }}
              className={classes.link}
            >
              <Button
                className={classes.rightButton}
                variant="contained"
                color="primary"
                endIcon={<AddCircleIcon color="secondary"></AddCircleIcon>}
              >
                Agregar inventario
              </Button>
            </Link>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ChipHeader;
